// extracted by mini-css-extract-plugin
export var alertIcon = "_t2-0";